import { ScheduleTemplateListItem } from "@common/schemas/domains/accounting/scheduleTemplate.schema";
import {
    AccountingSchedulesView,
    AccountingSchedulesViewColumn,
} from "@common/types/views/accountingSchedulesView";
import { ViewType } from "@common/types/views/views";
import { ViewConfig } from "@lib/views";

/**
 * Column model for the hand-rolled Policies table. It only feeds
 * `ColumnSettings` (names, mutability) and the ordered list of visible
 * columns; the table renders its own cells, so no `cell` renderers here.
 */
export const schedulesTableViewConfig: ViewConfig<
    ScheduleTemplateListItem,
    AccountingSchedulesViewColumn,
    never
> = {
    columns: {
        [AccountingSchedulesViewColumn.GROUP]: {
            accessorKey: "group",
            name: "Groups",
            header: "Groups",
            immutable: true,
            minSize: 110,
        },
        [AccountingSchedulesViewColumn.NAME]: {
            accessorKey: "name",
            name: "Name",
            header: "Name",
            required: true,
            minSize: 200,
        },
        [AccountingSchedulesViewColumn.DESCRIPTION]: {
            accessorKey: "description",
            name: "Description",
            header: "Description",
            minSize: 200,
        },
        [AccountingSchedulesViewColumn.JOURNAL_ENTRIES]: {
            accessorKey: "journalEntryCount",
            name: "Journal entries",
            header: "Journal entries",
            minSize: 160,
        },
        [AccountingSchedulesViewColumn.ENTITIES]: {
            accessorKey: "entityIds",
            name: "Entities",
            header: "Entities",
            minSize: 160,
        },
        [AccountingSchedulesViewColumn.STATUS]: {
            accessorKey: "status",
            name: "Status",
            header: "Status",
            minSize: 110,
        },
        [AccountingSchedulesViewColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            immutable: true,
            hiddenFromSettings: true,
            minSize: 120,
        },
    },
};

export const SCHEDULES_TABLE_DEFAULT_VIEW: AccountingSchedulesView = {
    type: ViewType.ACCOUNTING_SCHEDULES,
    columns: [
        { id: AccountingSchedulesViewColumn.GROUP },
        { id: AccountingSchedulesViewColumn.NAME },
        { id: AccountingSchedulesViewColumn.DESCRIPTION },
        { id: AccountingSchedulesViewColumn.JOURNAL_ENTRIES },
        { id: AccountingSchedulesViewColumn.ENTITIES },
        {
            id: AccountingSchedulesViewColumn.ACTIONS,
            options: { pin: "right" },
        },
    ],
    filters: {},
    options: {},
};
